module.exports = __webpack_public_path__ + "static/img/login-bg2.d7bc6ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login-bg2.png
// module id = oXSb
// module chunks = 9